import { Pagination as AntPagination } from 'antd';
//import './Pagination.scss';


const Pagination = ({
  total,
  pageSize,
  current, 
  showSizeChanger = false,
  defaultCurrent = 1,
  className = '',
  ...others
}) => {
  return (
    <AntPagination
      className={`AntPagination ${className}`}
      showSizeChanger={showSizeChanger}
      defaultCurrent={defaultCurrent}
      total={total}
      pageSize={pageSize}
      current={current}
      {...others}
    />
  )
}

export default Pagination